import * as React from 'react';

interface RadioProps<T extends string, K extends string> {
    options: { [T in K]: string };
    value: T;
    onChange: (key: T) => any;
}

export function Radio<T extends string, K extends string = T>({ options, value, onChange }: RadioProps<T, K>) {
    const changeHandler = (key: T) => () => onChange(key);

    return (
        <div className="field radio">
            {Object.entries(options).map(([key, label]: [T, string]) => (
                <div
                    key={key}
                    className={`option ${key == value ? 'checked' : ''}`}
                    onClick={changeHandler(key)}
                >
                    {label}
                </div>
            ))}
        </div>
    );
}

